import { Component, Input, output } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-push-button-form',
  templateUrl: './PushButtonForm.component.html',
  styleUrl: './PushButtonForm.component.css',
  imports: [MatFormFieldModule, MatInputModule, FormsModule]
})

export class PushButtonFormComponent {

  @Input() label: string = 'label';
  @Input() id: string = '';
  @Input() componentId: string = '';
  @Input() componentName: string = '';
  handleName=output<{value: string, field:string}>()
  handleId=output<{value: string, field:string}>()

  handleNameChange(value: string){
    this.handleName.emit({value, field: 'componentName'})
  }

  handleIdChange(value: string){
    this.handleId.emit({value, field: 'componentId'})
  }
  
}